import Component from '@bythepixel/component-loader';

export default class DynamicTextArea extends Component {
  static loaderPriority = 'in-view';
  static selector = '[data-comp-dynamic-text-area]';

  constructor(containerEl) {
    super(containerEl);
    this.init();
    this.initialTextAreaHeight = this.$container.style.height;
  }

  init() {
    this.$container.addEventListener('input', () => {
      this.$container.style.height = this.initialTextAreaHeight;
      if (this.$container.value) {
        this.$container.style.height = `${this.$container.scrollHeight}px`;
      } else {
        this.$container.style.height = '';
      }
    });
  }
}
